
import _ from 'lodash';
import { color_shades_dark, color_shades_darkest, color_shades_lighter, color_text_link } from '../../../constants/colors';
import styled from '@emotion/styled';
import React, { useEffect } from 'react';
import ResponsesContainer from '../../../hooks/ResponsesContainer';
import CustomScrollbars from '../../../components/structure/CustomScrollbars';
import SearchField from '../../../components/forms/SearchField';
import Button from '../../../components/general/Button';
import Loader from '../../../components/general/Loader';
import TooltipWrapper from '../../../components/general/TooltipWrapper';
import set from 'lodash';
import { getEditUrl, getPrettyEditUrl } from '../../../models/extensions';
import { getBaseUrl } from '../../../constants/Urls';
import { Link } from 'react-router-dom';
const deleteIcon = require('../../../content/images/bin-2.svg');

interface ResponseChooserProps {
    appId: string;
    chooseResponse: (responseId: string) => void;
    showUsage?: boolean;
    usedIn?: {
        contentItemId: string,
        applicationFeatureId?: string,
        responseInstanceId?: string,
        featureTypeId?: string
    }[]
    currentResponseId?: string;
}
const ResponseChooser: React.FC<ResponseChooserProps> = (props) => {
    const responseContainer = ResponsesContainer.useContainer();
    const [areYouSureIds, setAreYouSureIds] = React.useState<string[]>([]);
    const [search, setSearch] = React.useState<string>("");
    const [usedIn, setUsedIn] = React.useState<any[]>(null);
    useEffect(() => {
        if (props.appId?.length) {
            responseContainer.loadApplicationResponses(props.appId, true);
        }
    }, [props.appId])

    useEffect(() => {
        if(props.currentResponseId?.length && props.showUsage) {
            responseContainer.loadResponse(props.currentResponseId, true).then((response) => {
                if (response?.usedIn?.length) {
                    setUsedIn(response.usedIn?.filter(i => i?.contentItemId?.length) ?? []);
                } else {
                    setUsedIn([]);
                }
            });
        }
    }, [props.currentResponseId, props.showUsage]);

    const responsesToRender = responseContainer.responses.filter(r => r?.name?.length && (!search?.length || r.name.toLowerCase().includes(search.toLowerCase())));
    return (
        <ContentContainer>
            <ParentDiv
                autoHeightMax="50vh"
                autoHeightMin="50vh"
            >
                <InnerContentContainer>
                    {responseContainer.loading || (props.showUsage && usedIn === null) ? <Loader /> :
                        props.showUsage ? 
                            <>
                                <div style={{ color: color_shades_darkest, marginBottom: "8px" }}>Used in:</div>
                                {usedIn.length === 0 ? <div style={{ color: color_shades_darkest }}>Not used</div> : null}
                                {usedIn.map((item, index) => {
                                    return (
                                        <ResponsePill key={index}>
                                            <StyledCILink target={"_blank"} to={getEditUrl(item.contentItemId, item.applicationFeatureId, item.featureTypeId)}>{`${getPrettyEditUrl(item.contentItemId, item.featureTypeId)}`}</StyledCILink>
                                        </ResponsePill>
                                    )
                                })}
                            </>
                            :
                            
                        <>
                            <SearchField
                                value={search}
                                onChange={(e) => {
                                    setSearch(e.target.value);
                                }}
                                boxType='square'
                            />
                            {!responsesToRender?.length && <div style={{ color: color_shades_darkest }}>No responses found</div>}
                            {
                                responsesToRender?.map((response, index) => {
                                    let tooltipText = response?.systemPrompt ?? response?.content ?? "No content yet";
                                    // only first 20 characters
                                    const tooltipLength = 100;
                                    if (tooltipText?.length > tooltipLength) {
                                        tooltipText = tooltipText.substring(0, tooltipLength) + "...";
                                    }
                                    return (
                                        <TooltipWrapper place="top" text={tooltipText} key={index}>
                                            <ResponsePill onClick={() => {
                                                props.chooseResponse(response.id);
                                            }} key={index}>
                                                <ResponseName>{response.name}</ResponseName>
                                                <RightOfPill>
                                                    {areYouSureIds.includes(response.id) ?
                                                        <AreYouSureDiv onClick={(e) => {
                                                            e.stopPropagation();
                                                            setAreYouSureIds(areYouSureIds.filter((id) => id !== response.id))
                                                        }}>
                                                            Are you sure?
                                                        </AreYouSureDiv>
                                                        : <></>}
                                                    <Button type="button" onClick={(e) => {
                                                        e.stopPropagation();
                                                        if (areYouSureIds.includes(response.id)) {
                                                            responseContainer.deleteResponse(response.id).then(() => {
                                                                responseContainer.loadApplicationResponses(props.appId, true);
                                                            })
                                                        } else {
                                                            setAreYouSureIds([...areYouSureIds, response.id])
                                                        }
                                                    }} themes={["medium-icon", "end"]} icon={deleteIcon} />
                                                </RightOfPill>
                                            </ResponsePill>
                                        </TooltipWrapper>
                                    )
                                })
                            }
                        </>
                    }
                </InnerContentContainer>
            </ParentDiv>
        </ContentContainer>
    )
}


// stop from wrapping text
const ResponseName = styled.div`
    max-width: 60%;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
`;
const StyledCILink = styled(Link)`
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    color: ${color_text_link};
`;
const ParentDiv = styled(CustomScrollbars)`
`;

const AreYouSureDiv = styled.div`
    margin-right: 8px;
    cursor: pointer;
    margin-top: 4px;
`
const RightOfPill = styled.div` 
    margin-left: auto;
    display: flex;
    flex-direction: row;
`;

const ContentContainer = styled.div`
    right: 0;
    z-index: 100;
    height: 50vh;
    background-color: white;
    border-radius: 8px;
    top: 0;
    position: absolute;
    width: 30vw;
    border: 1px solid ${color_shades_dark};
`;

const InnerContentContainer = styled.div`
    padding: 16px;
    padding-top: 16px;
    padding-bottom: 16px;
`;


const ResponsePill = styled.div`
    height: 32px;
    border: 1px solid ${color_shades_dark};
    border-radius: 8px;
    margin: 0 0px 8px 0px;
    padding: 16px;
    cursor: pointer;
    background: ${color_shades_lighter};
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 14px;
`;
export default ResponseChooser;